import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import './Header.scss';
import headerLogo from '../../../Assets/Images/header_logo.png';
export default function Header() {

  const [ setMobileMenu , mobileMenu ] = useState(false)

  return (
    <>
    <header className='headerWrap'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='mainHeader'>
              <div className='header-left'>
                <NavLink to="/"><img src={headerLogo} /></NavLink>
              </div>
              <div className='header-center'>
                {/* <div class="hamburger-menu" onClick={() => mobileMenu(!setMobileMenu)}>
                 open
                </div> */}
                <div className='navbar-inner'>
                  <ul>
                    <li>
                    <NavLink to="/menu">Menus</NavLink>
                    </li>
                    <li>
                      <NavLink to="/aboutus">
                      About
                      </NavLink>

                    </li>
                    <li>
                      <NavLink to="/gallery">Gallery</NavLink>
                      </li>
                    <li>
                      <NavLink to="/contactus">Contact Us</NavLink>
                    </li>
                  </ul>
                </div>
                <div className='mobile-menu' onClick={() => mobileMenu(!setMobileMenu)}>
                    <i class="fa-solid fa-bars"></i>
                </div>
              </div>
            </div>            
          </div>
        </div>
      </div>
    </header>

        <div className={ setMobileMenu ? 'mobile-sidebar-design sidebar-show' : 'mobile-sidebar-design sidebar-hidden' }>
          <div className="mobile-header">
                <img src={headerLogo} alt="headerLogo"/>
                <i onClick={() => mobileMenu(false)} class="fa-solid fa-xmark"></i>
          </div>
          <div className='mobile-menu'>
                <ul onClick={() => mobileMenu(false)}>
                <NavLink to="/menu" >
                  <li onClick={() => mobileMenu(false)}>Menus</li>
                  </NavLink>
                  <NavLink to="/aboutus">
                  <li onClick={() => mobileMenu(false)}>About</li>
                 </NavLink>
                  <NavLink to="/gallery">
                  <li onClick={() => mobileMenu(false)}>Gallery</li>
                  </NavLink>
                  <NavLink to="/contactus">
                  <li onClick={() => mobileMenu(false)}>Contact Us</li>
                  </NavLink>
                </ul>
          </div>
        </div>
    
    </>
  )
}